export const DEFAULT_COUNTRY_NAME = 'Colombia';
export const DEFAULT_ID_TYPE = 'CC';

const normalizeText = (value) => (value || '').trim().toLowerCase();

export const isColombiaCountry = (pais) => {
    const name = normalizeText(pais?.Nombre);
    return name === 'colombia' || name.includes('colombia');
};

export const sortPaisesWithColombiaFirst = (paises = []) => {
    const list = [...paises];
    list.sort((a, b) => {
        const aCol = isColombiaCountry(a);
        const bCol = isColombiaCountry(b);
        if (aCol && !bCol) return -1;
        if (!aCol && bCol) return 1;
        return (a.Nombre || '').localeCompare(b.Nombre || '', 'es');
    });
    return list;
};

export const toPaisSelectValue = (pais) => `${pais.Codigo} - ${pais.Nombre}`;

export const mapPaisesToSelectOptions = (paises = []) =>
    sortPaisesWithColombiaFirst(paises).map((pais) => ({
        value: toPaisSelectValue(pais),
        label: pais.Nombre,
    }));

export const getDefaultColombiaCountryValue = (paises = []) => {
    const colombia = paises.find(isColombiaCountry);
    return colombia ? toPaisSelectValue(colombia) : '';
};

const isBogotaMunicipio = (municipio) => {
    const name = normalizeText(municipio?.Nombre);
    return name.includes('bogot');
};

export const sortMunicipiosWithBogotaFirst = (municipios = []) => {
    const list = [...municipios];
    list.sort((a, b) => {
        const aBogota = isBogotaMunicipio(a);
        const bBogota = isBogotaMunicipio(b);
        if (aBogota && !bBogota) return -1;
        if (!aBogota && bBogota) return 1;
        return (a.Nombre || '').localeCompare(b.Nombre || '', 'es');
    });
    return list;
};

export const mapMunicipiosToSelectOptions = (municipios = []) =>
    sortMunicipiosWithBogotaFirst(municipios).map((municipio) => ({
        value: `${municipio.Codigo} - ${municipio.Nombre}`,
        label: municipio.Nombre,
    }));

/**
 * Aplica Colombia como país por defecto cuando el formulario aún no tiene valor.
 */
export const applyColombiaCountryDefaults = (formData, paises, existingProfile = {}) => ({
    ...formData,
    birthCountry: formData.birthCountry || existingProfile.birthCountry || getDefaultColombiaCountryValue(paises),
    residenceCountry: formData.residenceCountry || existingProfile.residenceCountry || getDefaultColombiaCountryValue(paises),
});
